<template>
  <main id="container">
    <section id="header-section">
      <img id="header-background" v-lazy="background" />
      <header>
        <h1>เทคนิค LTF/RMF</h1>
        <div
          v-if="highlight"
          class="post-card"
          id="highlight"
          @click="open(highlight.link)"
          data-action="open_post"
          :data-postid="highlight.id"
          data-listname="lr_top"
        >
          <div class="image">
            <img class="thumbnail" :src="highlight.post_thumbnail_url" />
          </div>
          <div class="content">
            <div class="top-description" v-html="highlight.brief ? highlight.title.rendered : ''"></div>
          </div>
        </div>
      </header>
    </section>
    <section id="fund-section">
      <h2>กองทุน LTF/RMF แนะนำโดย FINNOMENA</h2>
      <div id="recommend-fund">
        <tabs>
          <tab name="LTF" :selected="true" data-action="open_tab" data-tab="lr_ltf">
            <div v-for="(fund, index) in ltf" :key="index" class="fund-list">
              <div class="fund-detail">
                <h3>{{fund.fund_code}}</h3>
                <p>{{fund.amc}}</p>
              </div>
              <div class="fund-action">
                <div
                  class="action-btn"
                  @click="route(fund.fund_id)"
                  data-action="open_fund"
                  :data-fundname="fund.fund_code"
                  data-listname="fund_lr"
                >
                  <i class="fas fa-exclamation-circle"></i>Detail
                </div>
                <div
                  class="action-btn"
                  @click="open(fund.review)"
                  data-action="open_post"
                  data-listname="lr"
                  :data-fundname="fund.fund_code"
                >
                  <i class="fas fa-comment-alt-dots"></i>Review
                </div>
              </div>
            </div>
          </tab>
          <tab name="RMF" data-tab="lr_rmf">
            <div
              v-for="(fund, index) in rmf"
              :key="index"
              class="fund-list"
              data-action="open_tab"
              data-tab="lr_rmf"
            >
              <div class="fund-detail">
                <h3>{{fund.fund_code}}</h3>
                <p>{{fund.amc}}</p>
              </div>
              <div class="fund-action">
                <div
                  class="action-btn"
                  @click="route(fund.fund_id)"
                  data-action="open_fund"
                  :data-fundname="fund.fund_code"
                  data-listname="fund_lr"
                >
                  <i class="fas fa-exclamation-circle"></i>Detail
                </div>
                <div
                  class="action-btn"
                  @click="open(fund.review)"
                  data-action="open_post"
                  data-listname="lr"
                  :data-fundname="fund.fund_code"
                >
                  <i class="fas fa-comment-alt-dots"></i>Review
                </div>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <div id="see-all-btn" @click="fundfilter()" data-action="view_all_lr">
        <i class="fas fa-briefcase"></i>ดูกองทุน LTF/RMF ทั้งหมด
      </div>
    </section>
    <section id="article-section">
      <h1>ความรู้ LTF/RMF</h1>
      <div
        v-for="(article, index) in articles"
        :key="index"
        class="post-card"
        @click="open(article.link)"
        data-action="open_post"
        :data-postid="article.id"
        :data-listname="`lr_bottom_${++index}`"
      >
        <div class="image">
          <img class="thumbnail" :src="article.post_thumbnail_url" />
        </div>
        <div class="description">
          <p class="block-ellipsis" v-html="article.title ? article.title.rendered : ''"></p>
          <p class="block-ellipsis-desc" v-html="article.brief ? article.brief : ''"></p>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import axios from "axios";
import { getPostByID } from "../../../store/api/article.js";
import Tab from "../../components/commons/Tab";
import Tabs from "../../components/commons/Tabs";
export default {
  components: {
    Tab,
    Tabs
  },
  metaInfo: {
    title: process.env.VUE_APP_NAME
  },
  data() {
    return {
      background: {
        src: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/background/ltf-rmf-header@3x.png`,
        error: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/background/ltf-rmf-header.png`,
        loading: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/background/ltf-rmf-header.png`
      },
      highlight: {},
      ltf: [],
      rmf: [],
      articles: []
    };
  },
  mounted: async function() {
    const { data: config } = await axios.get("/config/ltf-rmf-config.json");

    let { data: highlight } = await getPostByID(config.highlight_article);
    if (highlight && Array.isArray(highlight)) {
      this.highlight = highlight[highlight.length - 1];
    }

    this.rmf = config.rmf;
    this.ltf = config.ltf;

    let { data: posts } = await getPostByID(config.articles.join(","));
    if (posts && Array.isArray(posts)) {
      this.articles = posts;
    }
  },
  methods: {
    open(url) {
      url = url + "?webview=line&bt_id=71";
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    },
    route(id) {
      this.$router.push({ path: "/miniapp/fund/overview?", query: { id } });
    },
    fundfilter() {
      this.$router.push({
        path: "/miniapp/market/fund?",
        query: { type: ["LTF", "RMF"], activeMenu: "miniapp-market-fund" }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$radius-size: 8px;

#container {
  margin-bottom: 30px;
  h1 {
    @extend %font-size-l;
    margin-bottom: 8px;
  }
  h2 {
    @extend %font-size-m;
    margin-bottom: 8px;
  }

  #highlight {
    margin-bottom: 0px;
    -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.55);
    -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.55);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.55);
  }

  #header-section {
    padding-top: 32px;
    padding-bottom: 32px;
    color: $color-white;
    @extend %container-style;
    @include multipleResponsive(phablet, tablet) {
      max-width: $max-width-tablet;
    }
    #header-background {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      @include responsive(mobile) {
        max-height: 279px;
      }
      @include responsive(phablet) {
        max-height: 280px;
      }
      @include responsive(tablet) {
        max-height: 280px;
      }
      @include responsive(desktop) {
        max-height: 450px;
      }
    }
    header {
      .post-card {
        pointer-events: auto;
        cursor: pointer;
        background-color: $color-white;
        border-radius: $radius-size;
        -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
        -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
        .image {
          pointer-events: none;
          @include multipleResponsive(phablet, tablet) {
            @include finCol(8, 12, 16px, middle, true, true);
            border-bottom-left-radius: 8px;
          }
          .thumbnail {
            object-fit: cover;
            border-top-left-radius: $radius-size;
            border-top-right-radius: $radius-size;
            display: block;
            width: 100%;
            @include multipleResponsive(phablet, tablet) {
              border-bottom-left-radius: 8px;
            }
          }
        }
        .content {
          pointer-events: none;
          @include multipleResponsive(phablet, tablet) {
            @include finCol(4, 12, 16px, middle, true, true);
            padding: 0 16px;
          }
          padding: 16px;
          margin: 0px;
          display: inline-block;
          .title {
            @extend %font-size-m;
            color: $color-normal-text;
            font-weight: bold;
          }
          .top-description {
            @extend %font-size-s;
            color: $color-normal-text;
            font-weight: bold;
            display: inline-block;
            display: -webkit-box;
            margin: 0 auto;
            -webkit-box-orient: vertical;
            overflow: hidden;
            height: 84px;
            -webkit-line-clamp: 3;
          }
        }
      }
    }
  }
  #fund-section {
    margin-bottom: 32px;
    color: $color-normal-text;
    @extend %container-style;
    @include multipleResponsive(phablet, tablet) {
      max-width: $max-width-tablet;
    }
    #recommend-fund {
      border-radius: $radius-size;
      border: solid 1px #e6e6e6;
      background-color: $color-white;
      .fund-list {
        display: flex;
        justify-content: space-between;
        border-bottom: solid 1px #e6e6e6;
        padding: 8px;
        .fund-detail {
          margin-left: 8px;
          h3 {
            @extend %font-size-s;
            color: $color-normal-text;
            margin: 0px;
          }
          p {
            @extend %font-size-ss;
            margin: 0px;
            color: $color-secondary-text;
          }
        }
        .fund-action {
          display: flex;
          .action-btn {
            cursor: pointer;
            text-align: center;
            vertical-align: middle;
            font-weight: bold;
            line-height: 42px;
            margin-top: 4px;
            height: 42px;
            width: 75px;
            @extend %font-size-ss;
            @include finRippleBtn(#f9f9f9, #f9f9f9, $color-normal-text);
            margin-left: 8px;
            border-radius: 4px;
            i {
              pointer-events: none;
              margin-right: 4px;
            }
          }
        }
      }
      .fund-list:last-child {
        border-bottom: none;
      }
    }
    #see-all-btn {
      cursor: pointer;
      margin-top: 16px;
      text-align: center;
      vertical-align: middle;
      @extend %font-size-s;
      font-weight: bold;
      padding: 12px;
      width: 100%;
      border-radius: 4px;
      @include finRippleBtn(#e6e6e6, #e6e6e6, $color-normal-text);
      i {
        pointer-events: none;
        margin-right: 8px;
      }
    }
  }
  #article-section {
    @extend %container-style;
    @include multipleResponsive(phablet, tablet) {
      max-width: $max-width-tablet;
    }
    .post-card {
      cursor: pointer;
      pointer-events: auto;
      margin-bottom: 16px;
      background-color: $color-white;
      border-radius: $radius-size;
      -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
      -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
      .image {
        pointer-events: none;
        @include multipleResponsive(phablet, tablet) {
          @include finCol(6, 12, 16px, middle, true, true);
        }
        .thumbnail {
          @include multipleResponsive(phablet, tablet) {
            border-bottom-left-radius: 8px;
            border-top-right-radius: 0px;
          }
          border-top-left-radius: $radius-size;
          border-top-right-radius: $radius-size;
          display: block;
          width: 100%;
        }
      }
      .description {
        pointer-events: none;
        @include multipleResponsive(phablet, tablet) {
          @include finCol(6, 12, 16px, top, true, true);
          padding: 16px;
        }
        @extend %font-size-s;
        color: $color-normal-text;
        padding: 16px;
        margin: 0px;
        font-weight: bold;
        .block-ellipsis {
          display: block;
          margin: 0;
          @extend %font-size-ss;
          @include multipleResponsive(phablet, tablet, desktop) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 5px;
          }
        }
        .block-ellipsis-desc {
          display: block;
          margin: 0; // 0 auto
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 2;
          height: 50px;
          font-weight: normal;
          @extend %font-size-ss;
          @include multipleResponsive(mobile) {
            display: none;
            color: $color-secondary-text;
          }
        }
      }
    }
  }
}
</style>